import * as React from "react";
import { memo, SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => {
  const {width = 16, height = 16} = props;
  return (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox={`0 0 ${height} ${width}`} fill="none">
      <path
        fill="#0E0E0E"
        d="M12.14 12.602A7.336 7.336 0 0 1 1.006 7.737a7.321 7.321 0 0 1 2.227-4.043L1.147 1.61 2.09.667l13.2 13.2-.944.942-2.207-2.207h.001ZM4.175 4.638a5.977 5.977 0 0 0-1.808 3.1 6.004 6.004 0 0 0 8.801 3.892l-1.352-1.352A3 3 0 0 1 5.679 6.14L4.175 4.639ZM8.828 9.29 6.667 7.129a1.667 1.667 0 0 0 2.16 2.16h.001Zm5.262 1.51-.954-.954a5.956 5.956 0 0 0 .934-2.108 6.004 6.004 0 0 0-7.483-4.442L5.535 2.245a7.336 7.336 0 0 1 9.897 5.493 7.297 7.297 0 0 1-1.342 3.061ZM8.034 4.742a3 3 0 0 1 3.18 3.18l-3.18-3.18Z"
      />
    </svg>
  );
};
const Memo = memo(SvgComponent);
export { Memo as EyeOff };
